import React from 'react';
import './RutaCargando.css';

/**
 * Fallback de <Suspense> para las rutas diferidas (P4 · code splitting).
 *
 * No muestra ningún dato: es un indicador de progreso, no un placeholder de
 * contenido (N1 — nunca datos de ejemplo, ni siquiera mientras carga).
 *
 * Aparece con 250 ms de retraso vía CSS para que un chunk que llega rápido no
 * produzca un parpadeo blanco.
 */
const RutaCargando = () => (
  <div className="rc-fallback" role="status" aria-live="polite">
    <div className="rc-fallback__anillo" aria-hidden="true" />
    <p className="rc-fallback__texto">Cargando</p>
  </div>
);

export default RutaCargando;
